import ContractCreateUpload from "./ContractCreateUpload";

export default ContractCreateUpload;
